import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit"
import { RootState } from "../../app/store"
import { ActionWrapper } from "../../lib/api-status/actionWrapper"
import { getError } from "../../lib/api-status/errorHandler"
import { IUser, IUserApprove } from "../admin/IUser"
import { FetchStatus, IStatus } from '../../lib/api-status/IStatus'
import { signupUser } from './signupApi'
import { ISignup } from "./ISignup"

type InitialState = {
  response: string | undefined,
  status: IStatus
  actionStatus: IStatus
}
const initialState: InitialState = {
  response: undefined,
  status: { fetchStatus: FetchStatus.IDLE },
  actionStatus: { fetchStatus: FetchStatus.IDLE }
}

export const signupUsersAsync = createAsyncThunk(
  'signupUsersAsync/create',
  async (args: ActionWrapper<ISignup>, { rejectWithValue }) => {
    console.log("fetchContributorDetailsAsync called...")
    try {
      if (args.argument) {
        const response = await signupUser(args.argument);
        return response.data;
      }
    } catch (reason) {
      console.log(reason)
      return rejectWithValue(getError(reason));
    }
  }
)


const signupSlice = createSlice({
  name: 'signup',
  initialState,
  reducers: {

  },
  extraReducers: builder => {
    builder.addCase(signupUsersAsync.pending, state => {

    })
      .addCase(
        signupUsersAsync.fulfilled,
        (state, action: PayloadAction<string>) => {
          console.log(action.payload);
          state.response = action.payload;
          state.status.fetchStatus = FetchStatus.IDLE;
        }
      )
      .addCase(signupUsersAsync.rejected, (state, action:any) => {
        //state.response = action.payload?.message;
        let errStr = "conflict"
        const errOut = "User already registed with the given Email. Try with different Email."
        state.response = action.payload?.message ? action.payload?.message.toLowerCase() == errStr ? errOut : action.payload?.message: "Error Contact Support";
        state.status.fetchStatus = FetchStatus.FAILED;
      })
  }
})
export default signupSlice.reducer
export const selectedSignup = (state: RootState) => state.signup;
